import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { initializeAuth } from '../redux/slices/authSlice';
import { refreshSession } from '../utils/sessionRefresh';

export const useTokenRefresh = () => {
  const dispatch = useDispatch();
  const { token, refreshToken } = useSelector(state => state.auth);
  useEffect(() => {
    const sync = event => { if (['sessionId', 'accessToken', 'refreshToken', null].includes(event.key)) dispatch(initializeAuth()); };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [dispatch]);
  useEffect(() => {
    if (!token || !refreshToken) return;
    const check = () => {
      try {
        if (jwtDecode(token).exp * 1000 - Date.now() < 5 * 60 * 1000) refreshSession().catch(() => {});
      } catch { /* A malformed token is rejected by the API. */ }
    };
    check();
    const interval = setInterval(check, 60 * 1000);
    return () => clearInterval(interval);
  }, [token, refreshToken]);
};
export default useTokenRefresh;
